export const PAYMENT_ERROR_STRING = {
  COUPON_APPLIES_TO_NOTHING: 'coupon_applies_to_nothing',
  TRIAL_ALREADY_TAKEN: 'TRIAL_ALREADY_TAKEN'
}